export enum EMALE_UNISEX_SIZES {
    "UNISEX_MALE_4"="male unisex 4",
    "UNISEX_MALE_5"="male unisex 5",
    "UNISEX_MALE_6"="male unisex 6",
    "UNISEX_MALE_6.5"="male unisex 6.5",
    "UNISEX_MALE_7"="male unisex 7",
    "UNISEX_MALE_7.5"="male unisex 7.5",
    "UNISEX_MALE_8"="male unisex 8",
    "UNISEX_MALE_8.5"="male unisex 8.5",
    "UNISEX_MALE_9"="male unisex 9",
    "UNISEX_MALE_9.5"="male unisex 9.5",
    "UNISEX_MALE_10"="male unisex 10",
    "UNISEX_MALE_10.5"="male unisex 10.5",
    "UNISEX_MALE_11"="male unisex 11",
    "UNISEX_MALE_11.5"="male unisex 11.5",
    "UNISEX_MALE_12"="male unisex 12",
    "UNISEX_MALE_13"="male unisex 13",
    "UNISEX_MALE_14"="male unisex 14",
}

export enum EFEMALE_UNISEX_SIZES {
    "UNISEX_FEMALE_6"="female unisex 6",
    "UNISEX_FEMALE_7"="female unisex 7",
    "UNISEX_FEMALE_8"="female unisex 8",
    "UNISEX_FEMALE_8.5"="female unisex 8.5",
    "UNISEX_FEMALE_9"="female unisex 9",
    "UNISEX_FEMALE_9.5"="female unisex 9.5",
    "UNISEX_FEMALE_10"="female unisex 10",
    "UNISEX_FEMALE_10.5"="female unisex 10.5",
    "UNISEX_FEMALE_11"="female unisex 11",
    "UNISEX_FEMALE_11.5"="female unisex 11.5",
    "UNISEX_FEMALE_12"="female unisex 12",
    "UNISEX_FEMALE_12.5"="female unisex 12.5",
    "UNISEX_FEMALE_13"="female unisex 13",
    "UNISEX_FEMALE_13.5"="female unisex 13.5",
    "UNISEX_FEMALE_14"="female unisex 14",
}

export enum EMALE_SIZES {
    "MALE_6"="male 6",
    "MALE_6.5"="male 6.5",
    "MALE_7"="male 7",
    "MALE_7.5"="male 7.5",
    "MALE_8"="male 8",
    "MALE_8.5"="male 8.5",
    "MALE_9"="male 9",
    "MALE_9.5"="male 9.5",
    "MALE_10"="male 10",
    "MALE_10.5"="male 10.5",
    "MALE_11"="male 11",
    "MALE_11.5"="male 11.5",
    "MALE_12"="male 12",
    "MALE_13"="male 13",
    "MALE_14"="male 14",
    "MALE_15"="male 15",
    "MALE_16"="male 16",
}


export enum EFEMALE_SIZES {
    "FEMALE_4"="female 4",
    "FEMALE_4.5"="female 4.5",
    "FEMALE_5"="female 5",
    "FEMALE_5.5"="female 5.5",
    "FEMALE_6"="female 6",
    "FEMALE_6.5"="female 6.5",
    "FEMALE_7"="female 7",
    "FEMALE_7.5"="female 7.5",
    "FEMALE_8"="female 8",
    "FEMALE_8.5"="female 8.5",
    "FEMALE_9"="females 9",
    "FEMALE_9.5"="female 9.5",
    "FEMALE_10"="female 10",
    "FEMALE_10.5"="female 10.5",
    "FEMALE_11"="female 11",
    "FEMALE_11.5"="female 11.5",
    "FEMALE_12"="female 12",
}
